import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from 'react-select'
import {notify} from 'react-notify-toast'
import DateUtils from './utils/DateUtils'
import WeekDates from './WeekDates'

class Scheduler extends Component {

  constructor () {
    super()

    this.state = {
      user: null,
      users: [],
      usersMap: new Map(),
      selectedEvent: null,
      userKey: null,
      targetDate: null,
      calendarEvents: new Map(),
      appointmentKey: null,
      eventsList: [],
      appointments: [],
      weekMod: 0,
      repeats: 0,
      userType: 0,
      weeks: 7,
      showForm: false
    }

    this.handleChangeDatePicker     = this.handleChangeDatePicker.bind(this)
    this.handleChangeUserSelect     = this.handleChangeUserSelect.bind(this)
    this.handleSelectCalendarDay    = this.handleSelectCalendarDay.bind(this)
    this.handleSelectCalendarEvent  = this.handleSelectCalendarEvent.bind(this)
    this.saveDate                   = this.saveDate.bind(this)
    this.addDate                    = this.addDate.bind(this)
    this.removeAppointment          = this.removeAppointment.bind(this)
    this.editAppointment            = this.editAppointment.bind(this)
    this.cancelEdit                 = this.cancelEdit.bind(this)
    this.nextWeek                   = this.nextWeek.bind(this)
    this.prevWeek                   = this.prevWeek.bind(this)
    this.handleUserType             = this.handleUserType.bind(this)
    this.handleRepeats              = this.handleRepeats.bind(this)
    this.handleNouserName           = this.handleNouserName.bind(this)
    this.handleWeeks                = this.handleWeeks.bind(this)
    this.newDate                    = this.newDate.bind(this)
    this.backToCalendar             = this.backToCalendar.bind(this)
  }

  render() {

    if ( this.state.user===null ) {
      return (
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
      )
    }

    // if user has no name in database, force to fill
    if ( this.state.user.name===undefined || this.state.user.name.trim()==='' ) {
      return (
        <div>
          <br/>
          Por favor, indica tu nombre en la sección de Configuración
          <br/>
          <Link to="/setup" style={{ fontWeight: 'bold', textDecoration: 'none', color: '#000000' }}>
            <button className='btn btn-lignht btn-sm' onClick={this.cancelEdit}>Ir a Configuración</button>
          </Link>
        </div>
      )
    }



    // load users list for combo
    let usersList = []
    this.state.users.map( user => {

      let name = user.email
      if ( user.name!==undefined ) {
        name = user.name
      }

      usersList.push({
        value: user.key,
        label: name
      })
      return true
    })

    return (
      <div className="module">
        <div className="container moduleHeaderDiv">
            <div className="row rowDiv"><h2>Gestión de Citas</h2></div>
            <br/>
            {
              !this.state.showForm ?
                <button className='btn btn-lignht btn-sm' onClick={this.newDate}>Nueva Cita</button>
              : null
            }
        </div>

        <div className="row">

          <div className="col-md-12 centered">
            <i className="material-icons floatLeft" title="Semana anterior"
              onClick={this.prevWeek}
              >navigate_before</i>
            Calendario de Citas
            <i className="material-icons floatRight" title="Semana siguiente"
              onClick={this.nextWeek}
              >navigate_next</i>
            <br/>
            {
              !this.state.showForm ?
                <div className="calendarDiv">
                  <WeekDates
                    weekMod={this.state.weekMod}
                    editAppointment={this.editAppointment}
                    />
                </div>
              : null
            }
          </div>

        </div>
        <br/>
        <div className="row">

          {
            this.state.showForm && this.state.user!==null && this.state.user.role!=='user'?
              <div className="col-md-12 centered schedulerForm">
                {
                  this.state.appointmentKey===null?
                    'Crear Nueva Cita'
                  :
                    'Editar Cita'
                }

                <div className="container">

                    <div className="formDiv">
                        <label className="col-form-label formLabel">Tipo Paciente</label>
                        <select className="form-control newsInput" 
                          ref="userType"
                          value={this.state.userType}
                          onChange={this.handleUserType}>
                          <option value="0">Paciente registrado</option>
                          <option value="1">Paciente no registrado</option>
                        </select>
                    </div>

                    {
                      this.state.userType===0?
                      <div className="formDiv">
                        <label className="col-form-label formLabel">Selecciona Paciente</label>

                        <Select className="reactSelect"
                          value={this.state.userKey}
                          onChange={this.handleChangeUserSelect}
                          options={usersList}
                          isSearchable="true"
                          isClearable="true"
                          />
                      </div>
                      : null
                    }

                    {
                      this.state.userType===1?
                        <div className="formDiv">
                          <label className="col-form-label formLabel">Nombre de Paciente</label>
                          <input className="form-control newsInput" 
                            ref="nouserName"
                            value={this.state.nouserName}
                            onChange={this.handleNouserName}
                            />
                        </div>
                      : null
                    }

                    <div className="formDiv">
                      <label className="col-form-label formLabel">Selecciona fecha/hora</label>
                      <br/>
                      <DatePicker
                        selected={this.state.targetDate}
                        onChange={this.handleChangeDatePicker}
                        locale="es"
                        dateFormat="DD/MM/YYYY HH:mm"
                        className="form-control dateInput"
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={30}                
                        />
                    </div>

                    { this.state.appointmentKey===null ? 
                    <div className="row">
                      <div className="formDiv">
                        <label className="col-form-label formLabel">Repetir</label>
                        <select className="form-control dateRepeats" 
                          ref="repeats"
                          value={this.state.repeats}
                          onChange={this.handleRepeats}>
                          <option value="0">No repetir</option>
                          <option value="1">1 vez</option>
                          <option value="2">2 veces</option>
                          <option value="3">3 veces</option>
                          <option value="4">4 veces</option>
                          <option value="5">5 veces</option>
                          <option value="6">6 veces</option>
                          <option value="7">7 veces</option>
                          <option value="8">8 veces</option>
                          <option value="9">9 veces</option>
                          <option value="10">10 veces</option>
                          <option value="11">11 veces</option>
                          <option value="12">12 veces</option>
                          <option value="13">13 veces</option>
                          <option value="14">14 veces</option>
                          <option value="15">15 veces</option>
                          <option value="16">16 veces</option>
                          <option value="17">17 veces</option>
                          <option value="18">18 veces</option>
                          <option value="19">19 veces</option>
                          <option value="20">20 veces</option>
                        </select>
                      </div>

                      <div className="formDiv">
                        <label className="col-form-label formLabel">Periodo</label>
                        <select className="form-control weeks" 
                          ref="weeks"
                          value={this.state.weeks}
                          onChange={this.handleWeeks}>
                          <option value="7">Cada semana</option>
                          <option value="14">Cada 2 semanas</option>
                        </select>
                      </div>
                    </div>
                    : null }

                    <br/>
                    <br/>
                    <div className="formDiv">
                        {
                          this.state.appointmentKey!==null ?
                          <button className='btn btn-lignht btn-sm floatRight' onClick={this.cancelEdit}>Cancelar Edición</button>
                          : null
                        }
                        {
                          this.state.appointmentKey!==null ?
                          <button className='btn btn-lignht btn-sm floatRight' onClick={() => this.removeAppointment(this.state.appointmentKey)}>Eliminar Cita</button>
                          : null
                        }
                        <button className='btn btn-lignht btn-sm floatRight' onClick={this.saveDate}>Guardar Cita</button>
                        <button className='btn btn-lignht btn-sm floatRight' onClick={this.backToCalendar}>Cancelar</button>
                        <br/>
                        <br/>
                    </div>            

                  </div>
                </div>
              :
              null
              }
              </div>
      </div>
    )
  }

  componentDidMount () {

    firebase.database().ref("users").on ( 'value', users => {
      let usersList = []
      let usersMap = new Map()
      let userObj = null
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        usersMap.set( u.key, u )
        if (u.role==='user'){
          usersList.push(u)
        }
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })
    
      this.setState({
        users: usersList,
        usersMap: usersMap,
        user: userObj
      })
    })
  }
  
  saveDate () {

    // validate user
    if ( ( this.state.userType===0 && this.state.userKey===null )
        || ( this.state.userType===1 && this.state.userKey==='' )
      ) {
      notify.show ('Indica paciente', 'warning', 1250);
      return false
    }
    // validate date
    if ( this.state.targetDate===null ) {      
      notify.show ('Indica fecha/hora', 'warning', 1250);
      return false
    }

    // get user reference: key for registered users, name string for no registered
    let userstr = ''
    console.log('this.state.userType: ' + this.state.userType )
    if ( this.state.userType===1 ) {
      userstr = this.state.nouserName
    } else {
      userstr = this.state.userKey.value
    }

    if (this.state.appointmentKey!==null) {
      this.updateDate (userstr)
    } else {
      this.addDate (userstr)
    }
  }

  updateDate (userstr) {
    firebase.database().ref("appointments").child(this.state.appointmentKey).set({
      user: userstr,
      date: this.state.targetDate.format('DD/MM/YYYY'),
      time: this.state.targetDate.format('HH:mm'),
      userType: this.state.userType
    }).then ( span => {      
      this.setState({
        targetDate: null,
        userKey: null,
        selectedEvent: null,
        appointmentKey: null,
        showForm: false
      })
      notify.show ('Cita modificada', 'success', 1250);
    })
    .catch( error => {
      notify.show ('Error guardando cita: ' + error, 'error', 1250);
    })
  }

  addDate (userstr) {

    const repeats = this.state.repeats
    const weeks = this.state.weeks
    const time = this.state.targetDate.format('HH:mm')
    let daysToAdd = 0
    console.log('weeks: ' + weeks)
    for ( var i=0; i<=repeats; i++){

      console.log('daysToAdd: ')
      console.log(daysToAdd)
      console.log('this.state.targetDate: ')
      console.log(this.state.targetDate.format('DD/MM/YYYY'))
      const date = new moment(this.state.targetDate).add('days', daysToAdd).format('DD/MM/YYYY')
      console.log('date: ')
      console.log(date)
      daysToAdd += parseInt(weeks)
      
      firebase.database().ref("appointments").push({
        user: userstr,
        date: date,
        time: time,
        userType: this.state.userType
      }).then ( span => {      
        this.setState({
          targetDate: null,
          userKey: null,
          selectedEvent: null,
          appointmentKey: null,
          showForm: false
        })
        notify.show ('Nueva cita guardada', 'success', 1250);
      })
      .catch( error => {
        notify.show ('Error guardando cita: ' + error, 'error', 1250);
      })
    }

  }

  cancelEdit () {
    this.setState({
      targetDate: null,
      userKey: null,
      selectedEvent: null,
      appointmentKey: null
    })
  }

  // LISTENERS METHODS
  removeAppointment (key) {
    firebase.database().ref("appointments").child(key).remove().then ( span => {

      this.setState({
        selectedEvent: null,
        targetDate: null,
        userKey: null,
        selectedEvent: null,
        appointmentKey: null
      })

      notify.show ('Cita eliminada', 'success', 1250);
    })
    .catch( error => {
      notify.show ('Error eliminando cita: ' + error, 'error', 1250);
    })
  }

  editAppointment(event) {
    /*
    console.log('editAppointment: ')
    console.log(event)

    let name = event.user 
    if ( event.userType===undefined || event.userType===0 ) {
      name = this.state.usersMap.get(event.user).name
    }

    let userType = event.userType
    if (userType===undefined) {
      userType = 0
    }

    this.setState({
      showForm: true,
      appointmentKey: event.key,
      targetDate: new moment(event.date+' '+event.time, 'DD/MM/YYYY HH:mm'),
      userKey: {
        label: name,
        value: event.user
      },
      nouserName: event.user,
      userType: userType
    })
    */
  }

  confirmAppointment (appKey) {
    
    firebase.database().ref("appointments").child(appKey).child("confirmed").set(true)
    .then ( span => {
      this.setState ({
        selectedEvent: null
      })
      notify.show ('Cita confirmada', 'sucess', 1250);
    })
    .catch( error => {
      notify.show ('Error confirmando cita: ' + error, 'error', 1250);
    })
  }

  
  rejectAppointment (appKey) {
    
    firebase.database().ref("appointments").child(appKey).child("confirmed").set(false)
    .then ( span => {
      this.setState ({
        selectedEvent: null
      })
      notify.show ('Cita rechazada', 'sucess', 1250);
    })
    .catch( error => {
      notify.show ('Error rechazando cita: ' + error, 'error', 1250);
    })
  }

  handleSelectCalendarEvent(event) {
    let eDate = new moment(event.start).format('DD/MM/YYYY')
    let events = this.state.calendarEvents.get(eDate)
    if (events===null || events===undefined) {
      events = []
    }
    
    this.setState({
      targetDate: new moment(event.start),
      eventsList: events
    })
  }

  handleSelectCalendarDay(event) {
    // date for input 
    let eDate = new moment(event.start).format('DD/MM/YYYY')
    // events list for selected date
    let events = this.state.calendarEvents.get(eDate)
    if (events===null || events===undefined) {
      events = []
    }

    // set sate
    this.setState({
      targetDate: new moment(event.start),
      eventsList: events
    })
  }

  handleChangeUserSelect (userKey) {
    this.setState({ 
      userKey: userKey 
    })
  }

  handleChangeDatePicker (value) {
    this.setState({
      targetDate: value
    })
  }

  nextWeek () {
    this.setState({
      weekMod: this.state.weekMod+1
    })
  }

  prevWeek () {
    this.setState({
      weekMod: this.state.weekMod-1
    })
  }

  
  handleRepeats() {
    this.setState({
      repeats: this.refs.repeats.value
    })
  }

  
  handleUserType() {
    this.setState({
      userType: parseInt(this.refs.userType.value)
    })
  }
  
  handleNouserName() {
    this.setState({
      nouserName: this.refs.nouserName.value
    })
  }
  
  handleWeeks() {
    this.setState({
      weeks: this.refs.weeks.value
    })
  }

  newDate () {
    this.setState({
      showForm: true,
      targetDate: null,
      userKey: null,
      selectedEvent: null,
      appointmentKey: null,
    })
  }

  backToCalendar() {
    this.setState({
      targetDate: null,
      userKey: null,
      selectedEvent: null,
      appointmentKey: null,
      showForm: false
    })
  }

}

export default Scheduler
